'use strict';

export default class ExpandableContactButton {
    isInitialized = false;

    init() {
        if (this.isInitialized) {
            return
        }
        const expandableContactButton = document.querySelector('.expandable-contact-button');
        const closeButton = document.querySelector('.expandable-contact-button__close')

        if (expandableContactButton) {
            this.isInitialized = true;
            this.offsetWidth = expandableContactButton.offsetWidth;
            expandableContactButton.classList.add('expandable-contact-button--loaded');
            const self = this;

            expandableContactButton.addEventListener('click', (e) => {
                if (e.target !== closeButton) {
                    const isCompressed = document.querySelector('.expandable-contact-button__compressed:not(.hidden)');

                    if (isCompressed) {
                        const compressedElement = document.querySelector('.expandable-contact-button__compressed:not(.hidden)');
                        const expandedElement = document.querySelector('.expandable-contact-button__expanded');
                        const expandedElementIsHidden = expandedElement.classList.contains('hidden');
                        compressedElement.classList.add('hidden');
                        if (expandedElementIsHidden) {
                            expandedElement.classList.remove('hidden');
                            expandableContactButton.classList.add('expandable-contact-button--expanded');
                        }
                    }
                }
            });

            closeButton.addEventListener('click', (e) => {
                const expandedElement = document.querySelector('.expandable-contact-button__expanded');
                const compressedElement = document.querySelector('.expandable-contact-button__compressed');
                expandedElement.classList.add('hidden');
                compressedElement.classList.remove('hidden');
                expandableContactButton.classList.remove('expandable-contact-button--expanded');
            });
        }
    }
    
    hide() {
        const expandableContactButton = document.querySelector('.expandable-contact-button');
        const isHidden = expandableContactButton.classList.contains('hidden');
        if (!isHidden) {
            expandableContactButton.classList.add('hidden');
        }
        else {
            expandableContactButton.classList.remove('hidden');
        }
    }
}
